import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, Collapse, Tooltip, Zoom } from '@material-ui/core';
import { Container, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Modal } from '@material-ui/core';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import CloudUpload from '@material-ui/icons/CloudUpload';

import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import QrCode from '@mui/icons-material/QrCode';
import ViewHeadline from '@material-ui/icons/ViewHeadline';
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import { connect, ConnectedProps } from 'react-redux';
import store from '../redux/store';
import { getUsuarios, deleteUsuario, createUsuario, updateUsuario } from '../redux/usuarios/actions';
import { getAllInventoryStart, consultProductStart, getInventoriesByCategory, getInventoriesByFilter } from '../redux/produtos/actions';
import { getCategorias, } from '../redux/categorias/actions';
import { fetchEmpresas, } from '../redux/empresas/actions';
import { getImagesByReferencia, } from '../redux/referencias/actions';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import { InputAdornment } from '@material-ui/core';
import { Email, Phone, Business, ExpandLess, ViewList, Close } from '@material-ui/icons';
import { green } from '@material-ui/core/colors';
import moment from 'moment'
import { VictoryBar, VictoryPie } from 'victory';
import { client, AUTH_USER, CREATE_REFERRAL, getUsers, whoami, UPDATE_USER, CREATE_USER, getCategories, getCompanies, filterRecommendation, findProfileByUser, filterChatgpt, filterReferral, UPDATE_RECOMMENDATION, REJECT_RECOMMENDATION } from '../graphqlClient/graphql'
import Notifications from './../components/notifications/Notifications';
import { Autocomplete, Button, Card, CardActions, CardContent, CardHeader, CardMedia, Divider, FormControlLabel, FormGroup, LinearProgress, Link, ListItemButton, ListSubheader, Stack, styled, Switch, useMediaQuery, useTheme, TextField as MuiTextField } from '@mui/material';
import { useChat } from '../components/Chat/ChatContext';
import ChatIcon from '@mui/icons-material/Chat';

import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Box from '@mui/material/Box';
import {
  useGridApiRef,
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridToolbar,
  GridToolbarContainer,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridValueGetterParams,
  GridToolbarExport,
} from '@mui/x-data-grid';

import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { DefaultizedPieValueType } from '@mui/x-charts';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { serverConfig } from '../api/apiConfig';
import { useMutation } from '@apollo/client';
// Core viewer
import { Viewer, Worker } from '@react-pdf-viewer/core';

// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { height } from '@mui/system';

/* import pdfjs from 'pdfjs-dist';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`; */


const workerUrl = new URL(
  'https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js',
  import.meta.url,
).toString();


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    textAlign: 'center',
    width: '100% !important',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    //alignItems: 'center',
    height: '100%',
  },
  content: {
    width: '100% !important',
    textAlign: 'center',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between!important',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  deleteButton: {
    marginLeft: theme.spacing(1),
  },
  addButton: {
    margin: theme.spacing(1),
    backgroundColor: green[500],
    color: 'white',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  modalContent: {
    margin: "0 auto!Important",
    alignSelf: "center",
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignContent: 'center',
    flexWrap: 'nowrap',
    //alignItems: 'flex-start',
    // justifyContent: 'center',
    textAlign: 'center',
    border: '1px solid green',
    width: '80%',
    maxHeight: '100vh',
    overflowY: 'auto',
  },
  listContainer: {
    width: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: theme.spacing(3),
    padding: theme.spacing(2),
    maxHeight: 'calc(100vh - 100px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'green',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: 'darkgreen',
    },
  },
  card: {
    width: 345,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    userSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    msUserSelect: 'none',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[10],
    },
  },
  cardContent: {
    flexGrow: 1,
    minHeight: 120,
    maxHeight: 120,
    overflow: 'hidden',
    userSelect: 'none',
    msUserSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    '& .custom-scrollbar': {
      '&::-webkit-scrollbar': {
        width: '4px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 128, 0, 0.3)',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: 'rgba(0, 128, 0, 0.5)',
      },
    },
  },
  irButton: {
    color: 'white',
    margin: 5
  },
  rejectButton: {
    color: '#FF3366 !important',
    borderColor: 'rgba(255, 51, 102, 0.4) !important',
    backgroundColor: 'rgba(255, 51, 102, 0.04) !important',
    fontWeight: 600,
    textTransform: 'none',
    margin: 5,
    '&:hover': {
      borderColor: '#FF3366 !important',
      backgroundColor: 'rgba(255, 51, 102, 0.12) !important',
      boxShadow: '0 0 10px rgba(255, 51, 102, 0.3)',
    }
  }
}));

const chartConfig = {
  backgroundColor: '#26872a',
  backgroundGradientFrom: '#43a047',
  backgroundGradientTo: '#66bb6a',
  color: (opacity = 1) => `#ffffff`,
  style: {
    borderRadius: 16
  }
};

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));


type PropsFromRedux = ConnectedProps<typeof connector>;

const ScoutersPage: React.FC<PropsFromRedux> = ({ usuarios, isLoadingInventory, empresas, imagesByReferencia, consultedProduts, produtos, user }) => {
  const { startChat } = useChat();
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  // Create new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const screenWidth: any = getWindowDimensions().width
  const screenHeight: any = getWindowDimensions().height
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
  const [selectedUsuario, setSelectedUsuario] = React.useState('');
  const [addUsuarioModalOpen, setAddUsuarioModalOpen] = React.useState(false);
  const [newUsuarioName, setNewUsuarioName] = React.useState('');
  const [newUsuarioPassword, setNewUsuarioPassword] = React.useState('');
  const [newUsuarioConfirmPassword, setNewUsuarioConfirmPassword] = React.useState('');
  const [newUsuarioEmail, setNewUsuarioEmail] = React.useState('');
  const [newUsuarioTelefone, setNewUsuarioTelefone] = React.useState('');
  const [newUsuarioEmpresa, setNewUsuarioEmpresa] = React.useState('');
  const [editUsuarioData, setEditUsuarioData] = React.useState<any>({});

  const [newUsuarioPermissoes, setNewUsuarioPermissoes] = React.useState<any>({});
  const [editUsuarioModalOpen, setEditUsuarioModalOpen] = React.useState(false);
  const [passwordOpen, setPasswordOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [category, setCategory] = React.useState('');
  const [selectedItem, setSelectedItem] = React.useState<any>({});
  const [categoriesToShow, setCategoriesToShow] = React.useState([{ nome: 'Todas', _id: 0 }]);

  const [total, setTotal] = React.useState<any>(0);
  const [inventoriesList, setInventoriesList] = React.useState<any>([]);
  const [tagsNotFound, setTagsNotFound] = React.useState<any>([]);
  const [tagsFound, setTtagsFound] = React.useState<any>([]);
  const [tagsLost, setTagsLost] = React.useState<any>([]);
  const [tagsEquals, setTagsEquals] = React.useState<any>([]);
  const [dataChart, setDataChart] = React.useState<any>([]);


  const [visible, setVisible] = React.useState(false);
  const [progress, setProgress] = React.useState(10);
  const [limit, setLimit] = React.useState(0);
  const permissoesList = ['administrador', 'gerente', 'basico']
  const [rows, setRows] = React.useState<any>([]);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
  const [selectedCategory, setSelectedCategory] = React.useState<any>({ key: 0, value: 'Filtro por unidade' });
  const [selectedUser, setSelectedUser] = React.useState<any>({ key: 0, value: 'Filtro por operador' });
  const [selectedProduto, setSelectedProduto] = React.useState<any>({ key: 0, value: 'Filtro por produto' });
  const [startDate, setStartDate] = React.useState<any>(null);
  const [endDate, setEndDate] = React.useState<any>(null);
  const [assignedReferrals, setAssignedReferrals] = React.useState<any>(0);
  const [referralsToBeReviewed, setReferralsToBeReviewed] = React.useState<any>(0);
  const [openPositions, setOpenPositions] = React.useState<any>(0);
  const [companies, setCompanies] = React.useState<any>([]);
  const [categories, setCategories] = React.useState<any>([]);
  const [referralData, setReferralData] = React.useState<any>({});
  const [recommendations, setRecommendations] = React.useState<any>([]);
  const [referrals, setReferrals] = React.useState<any>([]);
  const [selectedScout, setSelectedScout] = React.useState<any>({});
  const [scoutInfo, setScoutInfo] = React.useState<any>(false);
  const [selectedRecommendation, setSelectedRecommendation] = React.useState<any>({});
  const [requestPanel, setRequestPanel] = React.useState<any>(false);

  const [openPdf, setOpenPdf] = React.useState<any>(false);
  const [defaultPdf, setDefaultPdf] = React.useState<any>('');
  const [favoriteFeedback, setFavoriteFeedback] = React.useState<any>(null);
  const [openReferral, setOpenReferral] = React.useState<any>(false);
  const [openReferralDetailsModal, setOpenReferralDetailsModal] = React.useState<any>(false);
  const [expanded, setExpanded] = React.useState<any>('');
  const [typeViewer, setTypeViewer] = React.useState<any>('recommendation');
  const handleExpandClick = (id: string) => {
    const newValue = expanded == id ? '' : id
    setExpanded(newValue);
  };
  const apiRef = useGridApiRef();

  const [CreateReferralMutation, { data }] = useMutation(CREATE_REFERRAL);
  const [UpdateRecommendationMutation, { data: updateRecommendationInput }] = useMutation(UPDATE_RECOMMENDATION);
  const [RejectRecommendationMutation] = useMutation(REJECT_RECOMMENDATION);

  const [openRejectModal, setOpenRejectModal] = React.useState<boolean>(false);
  const [recommendationToReject, setRecommendationToReject] = React.useState<any>(null);
  const [rejectLoading, setRejectLoading] = React.useState<boolean>(false);

  const handleOpenRejectModal = (recom: any) => {
    setRecommendationToReject(recom);
    setOpenRejectModal(true);
  };

  const handleCloseRejectModal = () => {
    if (rejectLoading) return;
    setOpenRejectModal(false);
    setRecommendationToReject(null);
  };

  const handleConfirmReject = async () => {
    if (!recommendationToReject || !user?._id) return;
    setRejectLoading(true);
    try {
      await RejectRecommendationMutation({
        variables: {
          id: recommendationToReject._id,
          scouterId: user._id
        }
      });

      // Optimistically remove from list
      setRecommendations((prev: any[]) => prev.filter((item: any) => item._id !== recommendationToReject._id));
      setReferralsToBeReviewed((prev: number) => Math.max(0, prev - 1));

      setOpenRejectModal(false);
      if (scoutInfo && selectedRecommendation?._id === recommendationToReject._id) {
        handlerCloseModal();
      }
      setRecommendationToReject(null);

      const notData = {
        type: 'info',
        message: 'Nomination request declined and removed from your queue.',
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      };
      Notifications(notData);

      // Re-fetch in background
      checkRecommendations(user);
    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message || 'Error declining recommendation request',
        title: 'wescout',
        timeOut: 3000,
        callback: () => { },
        priority: true,
      };
      Notifications(notData);
    } finally {
      setRejectLoading(false);
    }
  };

  const updateMutation = async (referralId: any) => {
    setLoading(true);
    const dataToSend = {
      _id: selectedRecommendation._id,
      status: "Referred to HR",
      details: "Referred to HR by " + user.name,
      referral: referralId,
      scouter: user._id
    }
    try {

      const updateRecommendationInput = dataToSend
      //console.log('updateRecommendationInput', dataToSend)

      const result = await UpdateRecommendationMutation({
        variables: {
          updateRecommendationInput
        },
        onCompleted: ({ updateRecommendation }) => {

          //console.log('updateRecommendation== > ', updateRecommendation);
          const notData = {
            type: 'success',
            message: `Referral to ${updateRecommendation?.company?.name} Created Successfully!`,
            title: 'wescout',
            timeOut: 2500,
            callback: () => { },
            priority: true,
          }
          //checkReferrals(user)
          //Notifications(notData)
          setLoading(false);
          checkRecommendations(user)
          //navigate('/scout')
          //setCompany(updateUser);
        }
      });
    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message,
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      //console.log("Error at updateRecommendation", error.message)
      setLoading(false);
    }
  }


  const handleAddReferral = async () => {
    const recom: any = selectedRecommendation
    if (!referralData.message || !referralData.email) {
      const notData = {
        type: 'error',
        message: `Please enter the e-mail of HR company and fill the message field`,
        title: 'wescout',
        timeOut: 2000,
        callback: () => { },
        priority: true,
      }


      Notifications(notData)
      return;
    }
    setLoading(true);
    const dataToSend = {
      scouter: user._id,
      scout: recom.scout._id,
      active: true,
      company: recom.company._id,
      recommendation: recom._id,
      joblink: recom.link,
      message: referralData.message,
      pdf: editUsuarioData.pdf,
      email: referralData.email,
      status: 'active',
      token: 'abc',

    }
    //console.log('dataToSend referral', dataToSend)
    /* setLoading(false);
    return; */
    // dataToSend.id = dataToSend._id


    try {

      const createReferralInput = dataToSend
      //console.log('createReferralInput', dataToSend)

      const result = await CreateReferralMutation({
        variables: {
          createReferralInput
        },
        onCompleted: ({ createReferral }) => {

          //console.log('referral created== > ', createReferral);
          const notData = {
            type: 'success',
            message: `Referral to ${createReferral?.company?.name} Created Successfully!`,
            title: 'wescout',
            timeOut: 2500,
            callback: () => { },
            priority: true,
          }

          checkReferrals(user)
          Notifications(notData)
          setLoading(false);
          updateMutation(createReferral._id)
          setRequestPanel(false)
          setOpenReferral(false)
          //navigate('/scout')
          //setCompany(updateUser);
        }
      });
    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message,
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      //console.log("Error at create referral", error.message)
      setLoading(false);
    }

  };

  const checkRecommendations = async (u: any) => {
    if (!u?.company) {
      return
    }
    setLoading(true)
    const objToSend = {
      //startDate,
      //endDate,
      //empresa:empresa
      //category:selectedCategory?._id || '',
      "company": u.company?._id || '',
      "active": true,
      "status": "Under Review",
      "excludeScouter": u._id || ''
    }
    //console.log('objToSend checkRecommendations recommendations', objToSend)

    const result: any = await filterRecommendation(objToSend)
    //console.log('filterRecommendation result ==>>', result)
    const validRecommendations = Array.isArray(result) ? result.filter((item: any) => {
      if (!item.scout) return false;
      if (item.rejectedScouters && Array.isArray(item.rejectedScouters)) {
        const isRejected = item.rejectedScouters.some((s: any) => (s?._id || s) === u._id);
        if (isRejected) return false;
      }
      return true;
    }) : [];
    setRecommendations(validRecommendations)
    setReferralsToBeReviewed(validRecommendations.length)
    setLoading(false)
    if (validRecommendations.length == 0) {
      setTypeViewer('referral')
      //handleAddRecommendations()
    } else {
      //setReferralsRemaining(result[0].amount)
      //setRecommendations(result)
    }
    return result
  }



  const checkReferrals = async (u: any) => {
    const objToSend = {
      //startDate,
      //endDate,
      //empresa:empresa
      //category:selectedCategory?._id || '',
      //"company": u.company?._id || '',
      "scouter": u._id
      //"active" : true

    }
    //console.log('objToSend get referrals', objToSend)

    const result: any = await filterReferral(objToSend)
    //console.log('filterReferral result ==>>', result)
    const validReferrals = Array.isArray(result) ? result.filter((item: any) => item.scout !== null) : [];
    setReferrals(validReferrals)
    setAssignedReferrals(validReferrals.length)

    setRows(validReferrals)
    //setReferralsToBeReviewed(validReferrals.length)
    if (validReferrals.length == 0) {
      //console.log('no referrals')

      //handleAddRecommendations()
    } else {
      if (typeViewer == 'referral') {
        apiRef.current.setColumnVisibility('_id', false);
      }

      //setReferralsRemaining(result[0].amount)
      //setRecommendations(result)
    }
    return result
  }

  const getCategoriesAsync = async () => {

    const result: any = await getCategories()
    //console.log('resutl ===>', result)

    if (result?.length) {
      setCategories(result)
    }
  }

  const getCompaniesAsync = async () => {

    const result: any = await getCompanies()
    //console.log('resutlgetCompanies ===>', result)

    if (result?.length) {
      setCompanies(result)
    }
  }

  /* useEffect(() => {
    changeFilter()

  }, [selectedUser, selectedCategory, selectedProduto, startDate, endDate]); */


  let timer: any
  useEffect(() => {
    //console.log('limit useEffect', limit)
    setProgress(limit)
    //if(limit == 0){
    //clearInterval(timer)
    return
    //}

    /* timer = setInterval(() => {
      console.log('progress',progress)
      console.log('limit',limit)
       
        setProgress((prevProgress) => 
        {
          console.log('prevProgress',prevProgress)
          const inc = limit
          if(prevProgress>=limit || inc>=limit){
            console.log('limpou',timer)
            clearInterval(timer);
            timer = 0
          }
          
          return(inc >= limit ? limit : inc)
        });
    }, 100); */

    //return clearInterval(timer)
  }, [limit]);

  /*   useEffect(() => {
      console.log('inventories ===>', inventories)
      if(inventories.length){
        const order = (a:any,b:any)=>{
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        }
        getImagesByReferencia(0)
        const newOrder = inventories.slice().sort(order)
        console.log('newOrder', newOrder)
        setInventoriesList(newOrder)
        setRows(newOrder)
      }
      
      //console.log('empresas' , empresas)
    }, [inventories]); */


  useEffect(() => {
    if (user?.name) {
      //console.log('checkReferrals', user)
      checkReferrals(user)
      checkRecommendations(user)
    }
  }, [user]);
  useEffect(() => {
    if (selectedScout?.name) {
      getProfileByUserAsync(selectedScout._id)
      getChatgptAsync(selectedScout)
    }
  }, [selectedScout]);


  const getProfileByUserAsync = async (userId: any) => {
    try {
      setLoading(true)
      const profile: any = await findProfileByUser(userId);
      //console.log('profile ==>>', profile)
      setLoading(false)
      setEditUsuarioData(profile)
    }
    catch (error) {
      //console.log("Erro no getUser >>>>>", error)
    }
  }

  const getChatgptAsync = async (userResume: any) => {
    const result: any = await filterChatgpt({ user: userResume._id, type: "airesumefeedback" })
    if (result?.length) {
      // Use the pdf from the isDefault record as primary source
      const defaultRecord = result.find((r: any) => r.isDefault === true)
      setDefaultPdf(defaultRecord?.pdf || '')
      setFavoriteFeedback(defaultRecord || null)
    } else {
      setDefaultPdf('')
      setFavoriteFeedback(null)
    }
  }

  const makeBullets = (val: any) => {
    let resp = ''
    if (val.length) {
      for (let z = 0; z < val.length; z++) {
        const valor = val[z]
        if (typeof valor != "string") {
          resp += makeBullets(valor) + "<br>"
        } else {
          resp += `* ${valor} <br>`
        }
      }
    } else {
      for (var i in val) {
        const valor = val[i]
        if (typeof valor != "string") {
          resp += "<h3>" + i + "</h3><br>" + makeBullets(valor)
        } else {
          resp += `* ${i}: ${valor} <br>`
        }
      }
    }
    return resp;
  }

  const makeFinalResult = (res: any) => {
    let resObj
    let final = ''
    if (res) {
      try {
        resObj = JSON.parse(res)
      } catch (e) {
        console.error('Error parsing AI response:', e);
        return `<p style="color: red;">Error: Could not parse AI response. Raw response: ${res}</p>`;
      }
      if (resObj) {
        for (var i in resObj) {
          if (i === 'grade') continue;
          const valor: any = resObj[i]
          final += '<h3 style="color: #00FFFF; margin-top: 18px; margin-bottom: 8px; font-weight: 600; text-transform: capitalize; border-bottom: 1px solid rgba(138, 46, 226, 0.2); padding-bottom: 4px;">' + i + "</h3>"
          if (typeof valor == 'object') {
            final += makeBullets(valor)
          } else {
            final += valor
          }
          final += '<br>'
        }
      }
      return final
    }
    return ''
  }



  const handleDeleteClick = (UsuarioId: string) => {
    //console.log('UsuarioId', UsuarioId)
    setSelectedUsuario(UsuarioId);
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirmation = () => {
    //console.log('selectedUsuario', selectedUsuario)
    deleteUsuario(selectedUsuario);
    setDeleteConfirmationOpen(false);
  };

  const getCategoriaNome = (id: any) => {
    const nome = categories.filter((item: any) => id == item._id)
    return nome.length ? nome[0].nome : id

  }



  const clearData = (d: any) => {
    const dateTransform = (moment(d).format('DD-MM-YYYY h:m'));
    return dateTransform
  }


  const checkItem = (item: any) => {
    let achou: any = false
    //console.log(item)
    for (var i in consultedProduts) {
      //console.log('i checkItem',i)
      /* const search = tagsFound.filter((item:any)=>{
        item._id == i
      })
      search.length ? achou = true : null */
      if (i == item) achou = consultedProduts[i]
    }
    //console.log("achou ==>> ",achou)
    return achou


  }

  interface Props {
    title: any
    subTitle: any
    itensList: []
    type: any
  }


  function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number },
  ) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            style={{ color: '#ffffff', fontWeight: 'bold' }}
            variant="caption"
            component="div"

          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }

  const ImageComponent = (obj: any) => {
    //console.log('ImageComponent', obj)
    //console.log('editados',editados)
    //setEditReferenciaData(obj.obj.row)
    let caminho: any = '';
    let image: any = '';
    let referencia = obj.obj?.referencia || ''
    if (referencia && imagesByReferencia?.length) {
      caminho = imagesByReferencia.filter((item: any) => referencia == item.idReferencia)[0]
      //console.log(caminho)
      if (caminho) {
        image = serverConfig.dev.url + 'imagens/imagem/' + caminho._id;
        return (
          <ListItemAvatar>
            <Avatar sx={{ width: 48, height: 48 }} variant='rounded' src={image}></Avatar>
          </ListItemAvatar>

          /*  {
             obj.obj?.nome ? (
               <Avatar.Accessory name='verified' backgroundColor={'white'} type='materialIcons' color={'#008800'}  size={20} />
             ) : (
               <Avatar.Accessory name='backup' backgroundColor={'white'} type='materialIcons' color={'#008800'}  size={20} />
             )
           } */



        )
        //console.log(image)

      } else {
        return (
          // <Avatar  icon={  { name: 'report-off', type:'materialIcons', color:'#008800', size:30, } } >
          //   <Avatar.Accessory backgroundColor={'white'} color={'#008800'} name='verified' type='materialIcons'  size={20}  />
          // </Avatar>
          <ListItemAvatar>
            <Avatar sx={{ width: 56, height: 56 }} variant='rounded' ><ImageIcon></ImageIcon></Avatar>
          </ListItemAvatar>


        )
      }

    } else {
      {/* <IconButton onClick={
          ()=>{
            //handleEditReferencia(obj.obj.row)
            }
          }>
          <ImageSearch />
        </IconButton> */}
      return (
        <ListItemAvatar>
          <Avatar><ImageIcon></ImageIcon></Avatar>
        </ListItemAvatar>

      )
    }

  }

  const handlerCloseModal = () => {
    setVisible(false)
    setLimit(0)
    setProgress(0)
    clearInterval(timer);
    setSelectedScout({})
    setScoutInfo(false)
    setOpenReferralDetailsModal(false)
    setLoading(false)
    setDefaultPdf('')
    setFavoriteFeedback(null)
  }

  const compare = (a: any, b: any) => {
    if (a.createdAt > b.createdAt)
      return -1
    else if (a.createdAt < b.createdAt)
      return 1
    else
      return 0

  }


  const changeCategoria = (cat: any) => {

    console.log('categoria id: ', cat)

    if (cat == 0) {
      getAllInventoryStart()
    } else {
      //get(cat)
    }

  }


  //init DataGrid dependencies

  const handleRowEditStop: GridEventListener<'rowEditStop'> = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  interface EditToolbarProps {
    setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
    setRowModesModel: (
      newModel: (oldModel: GridRowModesModel) => GridRowModesModel,
    ) => void;
  }

  const _ = (id: GridRowId) => () => {
    setRows(rows.filter((row: any) => row._id !== id));
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row._id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row._id !== id));
    }
  };

  const processRowUpdate: any = (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    //console.log('newRow', newRow)
    //setEditProdutoData(newRow)
    setRows(rows.map((row: any) => (row._id === newRow._id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };


  const columns: GridColDef[] = [
    { field: '_id', headerName: 'ID', flex: 1, minWidth: 110 },
    {
      field: 'createdAt',
      headerName: 'Data',
      type: 'Date',
      flex: 1.2,
      minWidth: 160,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => clearData(params.row.createdAt)
    },

    {
      field: 'scout',
      headerName: 'Scout',
      flex: 1.5,
      minWidth: 160,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.scout?.name || ''
    },

    {
      field: 'company',
      headerName: 'Company',
      flex: 1,
      minWidth: 120,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.company?.name || ''
    },
    {
      field: 'joblink',
      headerName: 'Job Link',
      flex: 2.5,
      minWidth: 280,
      editable: false,
      //valueGetter: (params: GridValueGetterParams) => params.row.conteudo.productsByCategory.length
    },

    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 120,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        //const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const item = rows.filter((item: any) => item._id == id)[0]
        return [

          <GridActionsCellItem
            icon={<Tooltip TransitionComponent={Zoom} title="Details" arrow>
              <IconButton className='iconDetail' color="primary" aria-label="Details" >
                <ViewHeadline />
              </IconButton>
            </Tooltip>}
            label="Details"
            className="textPrimary"
            onClick={() => {
              console.log(item)
              showRequest(item)

            }}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<Tooltip TransitionComponent={Zoom} title="Chat" arrow>
              <IconButton className='iconDetail' color="primary" aria-label="Chat" >
                <ChatIcon />
              </IconButton>
            </Tooltip>}
            label="Chat"
            className="textPrimary"
            onClick={() => {
              startChat(item.scout._id)
            }}
            color="inherit"
          />,

        ];
      },
    },


  ];

  const hiddenFields = ['_id', 'id', 'ID'];

  const getTogglableColumns = (columns: GridColDef[]) => {
    console.log('getTogglableColumns', columns)
    return columns
      .filter((column) => !hiddenFields.includes(column.field))
      .map((column) => column.field);
  };

  interface AutocompleteOption {
    categoria: string;
  }

  const changeFilter = () => {

    const objToSend = {
      startDate,
      endDate,
      categoria: selectedCategory?._id || '',
      usuario: selectedUser?._id || '',
      produto: selectedProduto?._id || '',
    }
    //console.log('objToSend', objToSend)


  }

  const showRequest = async (refer: any) => {
    //console.log('showRequest', refer);
    //return;
    setReferralData(refer)
    const recom = refer.recommendation
    console.log('recom', recom)
    await getProfileByUserAsync(refer.scout._id)
    setSelectedRecommendation(recom)
    setSelectedScout(refer.scout)
    setOpenReferralDetailsModal(true)
  }
  const acceptRequest = (recom: any) => {
    console.log('recom', recom)
    setSelectedRecommendation(recom)
    setSelectedScout(recom.scout)
    setRequestPanel(true)
    //handleAddReferral(recom)
  }
  const handleScoutInfo = (recom: any) => {
    console.log('recom', recom)
    setSelectedRecommendation(recom)
    setSelectedScout(recom.scout)
    setScoutInfo(true)
    //setRequestPanel(true)
    //handleAddReferral(recom)
    //setRequestPanel(true)

  }

  const CustomToolbar = () => (
    <input value={'limpar'} onChange={(event: any) => setNewUsuarioName(event.target.value)} />
  );

  return (
    <Container maxWidth="lg" disableGutters className={classes.container}>
      <div className={classes.root}>
        <div className={classes.content}>
          {/* <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button> */}
          <Typography variant="h4" className={'title'}>
            Scouter ({user?.company?.name || ''})
          </Typography>
          {loading ? (
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          ) : null}

          {/* <FormControl fullWidth>
              <InputLabel className={'text'} htmlFor="tipo-select">Itens por Unidade</InputLabel>
              <Select
                className={classes.select}
                value={selectedCategoria}
                onChange={(e:any) => {

                  setSelectedCategoria( e.target.value )
                  changeCategoria( e.target.value)
                  
                }}
                inputProps={{
                  name: 'categoria',
                  id: 'tipo-select',
                }}
              >
                {categoriasToShow.map((cat: { _id: any; nome: any; }) => (
                  <MenuItem className={'text'} key={cat._id} value={cat._id}>
                    {cat.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          <Box sx={{ width: '100%', height: 'auto', }} style={{
            padding: '10px', paddingBottom: '10px',
            borderColor: 'green',
            borderWidth: '2px',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignContent: 'center',
            justifyContent: 'space-evenly',
            alignItems: 'center'
          }}
          >
            <Button variant="contained" className='button-referral' sx={{ minHeight: 48, m: 1 }} onClick={() => {
              console.log("rows", rows)
              setTypeViewer('referral')
            }} >
              Assigned Referrals
              <Avatar sx={{ bgcolor: '#31D841', marginLeft: '10px' }} aria-label="recipe">
                {assignedReferrals}
              </Avatar>

            </Button>
            <Button variant="contained" className='button-referral' sx={{ minHeight: 48, m: 1 }} onClick={() => setTypeViewer('recommendation')}  >
              Referrals  to be reviewed
              <Avatar sx={{ bgcolor: '#31D841', marginLeft: '10px' }} aria-label="recipe">
                {referralsToBeReviewed}
              </Avatar>

            </Button>
            {/* <Button variant="contained" className='button-referral'  >
                        Open positions
                            <Avatar sx={{ bgcolor: '#31D841' }} aria-label="recipe">
                                {openPositions}
                            </Avatar>

                        </Button> */}
          </Box>

          {/* <Box sx={{ width: '100%', alignItems: "center" }} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignSelf: 'center', paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>
            <Button variant='outlined' onClick={() => setTypeViewer('recommendation')}>REFERRALS TO BE REVIEWED</Button>
            <Button onClick={() => {
              console.log("rows", rows)
              setTypeViewer('referral')
            }}>ASSIGNED REFERRALS</Button>
          </Box> */}

          <Box sx={{ width: '100%', alignItems: "center" }} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignSelf: 'center', paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>


            {typeViewer == "referral" ?
              <>
                {rows.length ? (
                  <Box sx={{ width: '100%' }}>

                    <DataGrid
                      apiRef={apiRef}
                      loading={isLoadingInventory}
                      getRowId={(row: { _id: any; }) => row._id}
                      //checkboxSelection
                      disableRowSelectionOnClick

                      onClipboardCopy={(copiedString) => console.log(copiedString)}
                      unstable_ignoreValueFormatterDuringExport
                      autoHeight={true}
                      rows={rows}
                      columns={columns}
                      initialState={{
                        sorting: {
                          sortModel: [{ field: 'createdAt', sort: 'desc' }],
                        },

                        pagination: {
                          paginationModel: {
                            pageSize: 15,
                          },
                        },
                      }}
                      pageSizeOptions={[5]}
                      //checkboxSelection

                      //editMode="row"
                      rowModesModel={rowModesModel}
                      onRowModesModelChange={handleRowModesModelChange}
                      onRowEditStop={handleRowEditStop}
                      processRowUpdate={processRowUpdate}
                      // slots={{
                      //   toolbar: EditToolbar,
                      // }}
                      slots={{ toolbar: GridToolbar }}
                      slotProps={{
                        toolbar: {
                          setRows, setRowModesModel, csvOptions: {
                            fileName: 'scouterDataBase_',
                            delimiter: ';',
                            utf8WithBom: true,
                          },
                          columns: {
                            columnVisibilityModel: {
                              ID: false,
                              _id: false,
                              createdAt: !isMobile,
                              joblink: !isMobile
                            },
                          },
                          columnsPanel: {
                            getTogglableColumns,
                          },
                          printOptions: { hideToolbar: true, disableToolbarButton: false }
                        },
                      }}



                    //toolbar: { printOptions: { getRowsToExport: getSelectedRowsToExport } },


                    />

                  </Box>
                ) : (<div style={{ margin: 15 }}>

                </div>)}
              </> :
              <>
                {recommendations && recommendations.length ? (
                  <div className={classes.listContainer}>
                    {recommendations.map((item: any) => (
                      <Card className={classes.card} key={item._id}>
                        <CardHeader
                          avatar={
                            <Avatar sx={{ bgcolor: '#31D841' }} aria-label="recipe">
                              {(item.scout?.name || "??").substring(0, 2)}
                            </Avatar>
                          }
                          title={item.scout?.name || "Unknown Scout"}
                          subheader={clearData(item.createdAt)}
                          titleTypographyProps={{ style: { userSelect: 'none' } }}
                          subheaderTypographyProps={{ style: { userSelect: 'none' } }}
                        />
                        <CardMedia
                          onClick={() => {
                            handleScoutInfo(item)
                          }}
                          width={150}
                          component="img"
                          height="150"
                          image={item.scout?.image ? serverConfig.dev.url + 'images/' + item.scout.image : "https://robohash.org/" + (item.scout?.name || item._id)}
                          alt="scout image"
                        />
                        <CardContent className={classes.cardContent}>
                          <Typography variant="body2" style={{ marginTop: 5, userSelect: 'none' }} >
                            <Link className='roxo' href={`${item.link}`} target="_blank" underline="hover">
                              {'Job link'}
                            </Link>
                          </Typography>
                        </CardContent>
                        <CardActions disableSpacing>
                          <Button variant='contained' size="small" className={classes.irButton} onClick={() => {
                            handleScoutInfo(item)
                          }}>Professional info</Button>

                          <IconButton aria-label="chat" onClick={() => startChat(item.scout?._id)} sx={{ color: 'primary.main' }}>
                            <ChatIcon />
                          </IconButton>

                          <ExpandMore
                            expand={expanded == item._id ? true : false}
                            onClick={() => { handleExpandClick(item._id) }}
                            aria-expanded={expanded == item._id}
                            aria-label="show more"
                          >
                            <ExpandMoreIcon />
                          </ExpandMore>
                        </CardActions>
                        <Collapse in={expanded == item._id} timeout="auto" unmountOnExit>
                          <CardContent style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '12px 16px' }}>
                            <Button className={classes.irButton} onClick={() => acceptRequest(item)} fullWidth>
                              Accept this request
                            </Button>
                            <Button
                              variant="outlined"
                              fullWidth
                              className={classes.rejectButton}
                              onClick={() => handleOpenRejectModal(item)}
                            >
                              Decline / Reject request
                            </Button>
                          </CardContent>
                        </Collapse>
                      </Card>
                    )

                    )}


                  </div>
                ) : (<div style={{ margin: 15 }}>
                  No requests found for the company {user?.company?.name || ''}
                  {/* <Tooltip TransitionComponent={Zoom} title="Clear" arrow>
                <IconButton onClick={()=>clearSelected()} size='small' className='iconDetail' color="primary" aria-label="Editar" >
                  <Close />
                </IconButton>
              </Tooltip> */}
                </div>)}
              </>

            }

          </Box>






          {/* {inventories.length ? (
            <div className={'listContainer'}>
              <List>
                {inventories.map((inventory: any, index: any) => (
                  <ListItem key={index} className={classes.listItem} divider>
                    <ListItemText
                    
                    primaryTypographyProps={{color:'#008800'}}
                    primary={getCategoriaNome(inventory.categoria)}
                    secondary={clearData(inventory.createdAt)}
                  />
                    
                    
                    <div>
                      <IconButton color="primary" aria-label="Editar" onClick={() => handlerSelectedItem(inventory)}>
                        <ViewList  />
                      </IconButton>
                      
                     
                    </div>
                  </ListItem>
                ))}
              </List>
            </div>
            
          ) : null} */}
          <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button>
        </div>
      </div>

      <Modal open={requestPanel} onClose={() => setRequestPanel(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
        <div style={{
          backgroundColor: '#0a0a0a',
          color: '#ffffff',
          width: isMobile ? '95%' : '90%',
          maxWidth: '1350px',
          maxHeight: '90vh',
          borderRadius: '16px',
          border: '1px solid rgba(138, 46, 226, 0.3)',
          boxShadow: '0 8px 32px 0 rgba(0, 255, 255, 0.15)',
          display: 'flex',
          flexDirection: 'column',
          outline: 'none',
          fontFamily: '"Outfit", "Inter", sans-serif',
          overflow: 'hidden'
        }}>
          {/* Modal Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            backgroundColor: '#111115'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <Avatar 
                src={selectedScout?.image ? serverConfig.dev.url + 'images/' + selectedScout.image : "https://robohash.org/" + (selectedScout?.name || "avatar")}
                style={{ width: '48px', height: '48px', border: '2px solid #00FFFF', boxShadow: '0 0 10px rgba(0, 255, 255, 0.3)' }}
              />
              <div style={{ textAlign: 'left' }}>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#ffffff' }}>
                  Accept Request for {selectedScout?.name || "Scout"}
                </h2>
                <span style={{ fontSize: '14px', color: '#00FFFF', fontWeight: 500 }}>
                  Nominate candidate for {selectedRecommendation?.company?.name || 'Company'}
                </span>
              </div>
            </div>
            <Button 
              onClick={() => setRequestPanel(false)} 
              style={{ 
                color: '#ffffff', 
                borderColor: 'rgba(255,255,255,0.3)',
                backgroundColor: 'rgba(255,255,255,0.05)',
                padding: '6px 16px',
                textTransform: 'uppercase',
                fontWeight: 600,
                fontSize: '12px'
              }}
              variant="outlined"
            >
              Close
            </Button>
          </div>

          {/* Modal Content - Scrollable */}
          <div style={{
            padding: '24px',
            overflowY: 'auto',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            backgroundColor: '#0a0a0a'
          }}>
            {/* Dynamic Two-Column Layout */}
            <div style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: '24px',
              width: '100%',
              alignItems: 'stretch'
            }}>
              {/* Left Column: Input Form & Personal Info */}
              <div style={{
                flex: isMobile ? '1 1 100%' : '0 0 38%',
                maxWidth: isMobile ? '100%' : '38%',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
              }}>
                {/* Nomination Form */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(0, 255, 255, 0.3)',
                  boxShadow: '0 0 10px rgba(0, 255, 255, 0.05)',
                  textAlign: 'left',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px'
                }}>
                  <h3 style={{ margin: '0 0 4px 0', color: '#00FFFF', fontSize: '18px', fontWeight: 600 }}>
                    Nomination Details
                  </h3>
                  <span style={{ fontSize: '13px', color: '#a0a0ab', marginBottom: '8px', display: 'block' }}>
                    Complete the HR recipient e-mail and intro message to send the referral.
                  </span>

                  <MuiTextField
                    autoFocus
                    variant="outlined"
                    label={`E-mail of ${selectedRecommendation?.company?.name || 'Company'} HR`}
                    value={referralData.email || ""}
                    onChange={(e) => setReferralData({ ...referralData, email: e.target.value })}
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: '#0a0a0a',
                        color: '#ffffff',
                        '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.15)' },
                        '&:hover fieldset': { borderColor: '#00FFFF' },
                        '&.Mui-focused fieldset': { borderColor: '#00FFFF' }
                      },
                      '& .MuiOutlinedInput-input': {
                        color: '#ffffff !important',
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.7) !important',
                        '&.Mui-focused': {
                          color: '#00FFFF !important'
                        }
                      },
                      '& input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 1000px #0a0a0a inset !important',
                        WebkitTextFillColor: '#ffffff !important',
                      }
                    }}
                  />

                  <MuiTextField
                    variant="outlined"
                    label="Intro text for your nomination"
                    multiline
                    minRows={4}
                    maxRows={6}
                    value={referralData.message || ""}
                    onChange={(e) => setReferralData({ ...referralData, message: e.target.value })}
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: '#0a0a0a',
                        color: '#ffffff',
                        '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.15)' },
                        '&:hover fieldset': { borderColor: '#00FFFF' },
                        '&.Mui-focused fieldset': { borderColor: '#00FFFF' }
                      },
                      '& .MuiOutlinedInput-input': {
                        color: '#ffffff !important',
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(255, 255, 255, 0.7) !important',
                        '&.Mui-focused': {
                          color: '#00FFFF !important'
                        }
                      },
                      '& textarea:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 1000px #0a0a0a inset !important',
                        WebkitTextFillColor: '#ffffff !important',
                      }
                    }}
                  />

                  <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                    <Button 
                      onClick={() => setRequestPanel(false)}
                      variant="outlined"
                      style={{
                        flex: 1,
                        color: '#ffffff',
                        borderColor: 'rgba(255,255,255,0.3)',
                        textTransform: 'none',
                        fontWeight: 600
                      }}
                    >
                      Cancel
                    </Button>
                    <Button 
                      onClick={handleAddReferral}
                      variant="contained"
                      style={{
                        flex: 1,
                        background: 'linear-gradient(45deg, #8A2BE2, #00FFFF)',
                        color: '#ffffff',
                        textTransform: 'none',
                        fontWeight: 600
                      }}
                    >
                      Send Referral
                    </Button>
                  </div>
                </div>

                {/* Candidate Details Section */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 16px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Candidate Professional Details
                  </h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Nowadays Location</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData?.location || 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Origin Location</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{selectedScout?.country || 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Years of Experience</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData?.yearsOfExperience ? `${editUsuarioData.yearsOfExperience} years` : 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>English Level</span>
                      <span style={{ color: '#00FFFF', border: '1px solid #00FFFF', padding: '2px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 600 }}>{selectedScout?.englishLevel || 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                      {selectedScout?.employed ? (
                        <span style={{ color: '#FF00FF', backgroundColor: 'rgba(255, 0, 255, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #FF00FF', fontSize: '12px', fontWeight: 600 }}>Employed</span>
                      ) : (
                        <span style={{ color: '#39FF14', backgroundColor: 'rgba(57, 255, 20, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #39FF14', fontSize: '12px', fontWeight: 600 }}>Open to Hire</span>
                      )}
                      {selectedScout?.opentorelocation && (
                        <span style={{ color: '#00FFFF', backgroundColor: 'rgba(0, 255, 255, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #00FFFF', fontSize: '12px', fontWeight: 600 }}>Open to Relocate</span>
                      )}
                      {selectedScout?.uePassport && (
                        <span style={{ color: '#FFFF00', backgroundColor: 'rgba(255, 255, 0, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #FFFF00', fontSize: '12px', fontWeight: 600 }}>UE Passport</span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Bio / Summary */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 12px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Bio / Professional Summary
                  </h3>
                  <p style={{ margin: 0, color: '#e4e4e7', fontSize: '14px', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
                    {editUsuarioData?.bio || 'No professional summary listed.'}
                  </p>
                </div>
              </div>

              {/* Right Column: AI Resume Feedback Analysis & PDF Viewer */}
              <div style={{
                flex: isMobile ? '1 1 100%' : '1 1 62%',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
              }}>
                {/* AI Matching Details */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '24px',
                  border: '1px solid rgba(0, 255, 255, 0.3)',
                  boxShadow: '0 0 15px rgba(0, 255, 255, 0.05)',
                  textAlign: 'left',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  minWidth: 0
                }}>
                  {/* Header: AI Matching Feedback */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(0, 255, 255, 0.2)', paddingBottom: '12px', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
                    <div>
                      <h3 style={{ margin: 0, color: '#00FFFF', fontSize: '18px', fontWeight: 600 }}>
                        AI Match Analysis
                      </h3>
                      <span style={{ fontSize: '12px', color: '#39FF14', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginTop: '2px' }}>
                        ★ Starred Feedback
                      </span>
                    </div>

                    {/* Compatibility Score */}
                    {favoriteFeedback?.grade ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <CircularProgressWithLabel
                          value={Number(favoriteFeedback.grade) * 10}
                          size={50}
                          style={{ color: '#39FF14' }}
                        />
                        <span style={{ fontSize: '12px', color: '#a0a0ab', fontWeight: 500 }}>Compatibility Score</span>
                      </div>
                    ) : null}
                  </div>

                  {/* Target Job link and CV View button */}
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '16px' }}>
                    {selectedRecommendation?.link && (
                      <Button
                        variant="outlined"
                        href={selectedRecommendation.link}
                        target="_blank"
                        style={{
                          borderColor: 'rgba(255, 255, 255, 0.15)',
                          color: '#ffffff',
                          textTransform: 'none',
                          fontSize: '13px',
                          fontWeight: 500
                        }}
                      >
                        🔗 View Job Listing
                      </Button>
                    )}

                    {(defaultPdf || editUsuarioData?.pdf) && (
                      <Button
                        variant="outlined"
                        onClick={() => setOpenPdf(true)}
                        style={{
                          borderColor: '#8A2BE2',
                          color: '#8A2BE2',
                          textTransform: 'none',
                          fontSize: '13px',
                          fontWeight: 600
                        }}
                      >
                        📄 Open CV PDF
                      </Button>
                    )}
                  </div>

                  {/* AI Target Job Context */}
                  {favoriteFeedback?.job && (
                    <div style={{
                      marginBottom: '16px',
                      padding: '10px 14px',
                      borderRadius: '8px',
                      backgroundColor: 'rgba(255, 255, 255, 0.03)',
                      borderLeft: '3px solid #FF00FF',
                      fontSize: '13px',
                      color: '#e4e4e7',
                      wordBreak: 'break-word',
                      overflowWrap: 'anywhere'
                    }}>
                      <strong style={{ color: '#FF00FF' }}>Target Job Description:</strong>{' '}
                      {favoriteFeedback.job}
                    </div>
                  )}

                  {/* Formatted Response Body */}
                  <div style={{
                    flex: 1,
                    overflowY: 'auto',
                    maxHeight: '620px',
                    paddingRight: '8px',
                    fontSize: '14px',
                    color: '#e4e4e7',
                    lineHeight: '1.6',
                    wordBreak: 'break-word',
                    overflowWrap: 'anywhere'
                  }} className="custom-scrollbar">
                    {favoriteFeedback?.response ? (
                      <div dangerouslySetInnerHTML={{ __html: makeFinalResult(favoriteFeedback.response) }} />
                    ) : (
                      <div style={{ color: '#a0a0ab', textAlign: 'center', padding: '40px 0' }}>
                        No starred AI Resume Feedback available for this profile.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal open={openReferralDetailsModal} onClose={() => handlerCloseModal()} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
        <div style={{
          backgroundColor: '#0a0a0a',
          color: '#ffffff',
          width: isMobile ? '95%' : '90%',
          maxWidth: '1350px',
          maxHeight: '90vh',
          borderRadius: '16px',
          border: '1px solid rgba(138, 46, 226, 0.3)',
          boxShadow: '0 8px 32px 0 rgba(0, 255, 255, 0.15)',
          display: 'flex',
          flexDirection: 'column',
          outline: 'none',
          fontFamily: '"Outfit", "Inter", sans-serif',
          overflow: 'hidden'
        }}>
          {/* Modal Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            backgroundColor: '#111115'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <Avatar 
                src={selectedScout?.image ? serverConfig.dev.url + 'images/' + selectedScout.image : "https://robohash.org/" + (selectedScout?.name || "avatar")}
                style={{ width: '48px', height: '48px', border: '2px solid #00FFFF', boxShadow: '0 0 10px rgba(0, 255, 255, 0.3)' }}
              />
              <div style={{ textAlign: 'left' }}>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#ffffff' }}>
                  {selectedScout?.name || "Unknown Scout"}
                </h2>
                <span style={{ fontSize: '14px', color: '#00FFFF', fontWeight: 500 }}>
                  {editUsuarioData.professionalTitle || 'No Title'}
                </span>
              </div>
            </div>
            <Button 
              onClick={() => handlerCloseModal()} 
              style={{ 
                color: '#ffffff', 
                borderColor: 'rgba(255,255,255,0.3)',
                backgroundColor: 'rgba(255,255,255,0.05)',
                padding: '6px 16px',
                textTransform: 'uppercase',
                fontWeight: 600,
                fontSize: '12px'
              }}
              variant="outlined"
            >
              Close
            </Button>
          </div>

          {/* Modal Content - Scrollable */}
          <div style={{
            padding: '24px',
            overflowY: 'auto',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            backgroundColor: '#0a0a0a'
          }}>
            {/* Dynamic Two-Column Layout */}
            <div style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: '24px',
              width: '100%',
              alignItems: 'stretch'
            }}>
              {/* Left Column: Referral Details & Personal Info */}
              <div style={{
                flex: isMobile ? '1 1 100%' : '0 0 38%',
                maxWidth: isMobile ? '100%' : '38%',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
              }}>
                {/* Referral / Submission Details Section */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(0, 255, 255, 0.3)',
                  boxShadow: '0 0 10px rgba(0, 255, 255, 0.05)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 16px 0', color: '#00FFFF', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(0, 255, 255, 0.2)', paddingBottom: '8px' }}>
                    Referral & Transaction Details
                  </h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Sent At</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{clearData(referralData.createdAt)}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Sent To (HR E-mail)</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{referralData.email || 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Status</span>
                      <span style={{ color: '#39FF14', fontWeight: 600, textTransform: 'uppercase', fontSize: '12px' }}>{referralData.status || 'Active'}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Nomination Message</span>
                      <p style={{ margin: 0, color: '#e4e4e7', fontSize: '14px', lineHeight: '1.5', whiteSpace: 'pre-wrap', backgroundColor: 'rgba(255,255,255,0.02)', padding: '10px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.05)', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                        {referralData.message || 'No nomination message provided.'}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Candidate Details Section */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 16px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Candidate Profile
                  </h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Location</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData.location || 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Years of Experience</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData.yearsOfExperience ? `${editUsuarioData.yearsOfExperience} years` : 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Status</span>
                      <span>
                        {editUsuarioData.employed ? (
                          <span style={{ color: '#FF00FF', backgroundColor: 'rgba(255, 0, 255, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #FF00FF', fontSize: '12px', fontWeight: 600 }}>Employed</span>
                        ) : (
                          <span style={{ color: '#39FF14', backgroundColor: 'rgba(57, 255, 20, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #39FF14', fontSize: '12px', fontWeight: 600 }}>Open to Hire</span>
                        )}
                      </span>
                    </div>
                    {editUsuarioData.englishLevel && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                        <span style={{ color: '#a0a0ab', fontSize: '14px' }}>English Level</span>
                        <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData.englishLevel}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Bio Summary Section */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 12px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Bio / Professional Summary
                  </h3>
                  <p style={{
                    margin: 0,
                    color: '#e4e4e7',
                    fontSize: '14px',
                    lineHeight: '1.6',
                    whiteSpace: 'pre-wrap'
                  }}>
                    {editUsuarioData.bio || 'No bio summary provided by the candidate.'}
                  </p>
                </div>

                {/* Curriculum and Links */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px'
                }}>
                  <h3 style={{ margin: 0, color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Documents & Links
                  </h3>
                  
                  {/* CV PDF Button */}
                  {(defaultPdf || editUsuarioData.pdf) ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <span style={{ fontSize: '13px', color: '#a0a0ab' }}>Uploaded CV: {defaultPdf || editUsuarioData.pdf}</span>
                      <Button 
                        variant='contained' 
                        onClick={() => setOpenPdf(true)}
                        style={{
                          background: 'linear-gradient(45deg, #8A2BE2, #00FFFF)',
                          color: '#ffffff',
                          fontWeight: 600,
                          textTransform: 'none'
                        }}
                      >
                        Open Curriculum Viewer
                      </Button>
                    </div>
                  ) : (
                    <span style={{ fontSize: '14px', color: '#a0a0ab' }}>No resume PDF uploaded.</span>
                  )}

                  {/* Target Job Link */}
                  {selectedRecommendation?.link && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '12px' }}>
                      <span style={{ fontSize: '13px', color: '#a0a0ab' }}>Target Job URL</span>
                      <Button
                        href={`${selectedRecommendation.link}`}
                        target="_blank"
                        variant="outlined"
                        style={{
                          color: '#39FF14',
                          borderColor: 'rgba(57, 255, 20, 0.4)',
                          backgroundColor: 'rgba(57, 255, 20, 0.05)',
                          fontWeight: 600,
                          textTransform: 'none'
                        }}
                      >
                        View Job Link
                      </Button>
                    </div>
                  )}
                </div>
              </div>

              {/* Right Column: AI Resume Feedback Analysis (Favorite) */}
              <div style={{
                flex: isMobile ? '1 1 100%' : '1 1 62%',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
              }}>
                {/* Favorite AI Feedback Card */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '24px',
                  border: '1px solid rgba(0, 255, 255, 0.3)',
                  boxShadow: '0 0 15px rgba(0, 255, 255, 0.05)',
                  textAlign: 'left',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  minWidth: 0
                }}>
                  {/* Header: AI Matching Feedback */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(0, 255, 255, 0.2)', paddingBottom: '12px', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
                    <div>
                      <h3 style={{ margin: 0, color: '#00FFFF', fontSize: '18px', fontWeight: 600 }}>
                        AI Match Analysis
                      </h3>
                      <span style={{ fontSize: '12px', color: '#39FF14', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginTop: '2px' }}>
                        ★ Starred Feedback
                      </span>
                    </div>
                    
                    {/* Animated/Glowing Matching Circular Score */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <CircularProgressWithLabel 
                        value={
                          favoriteFeedback?.response ? (
                            (() => {
                              try {
                                const parsed = JSON.parse(favoriteFeedback.response);
                                if (parsed.grade !== undefined) {
                                  let num = parseFloat(String(parsed.grade));
                                  if (!isNaN(num)) {
                                    if (num <= 1) num = num * 100;
                                    else if (num <= 10) num = num * 10;
                                    return Math.round(num);
                                  }
                                }
                              } catch(e) {}
                              return 80;
                            })()
                          ) : 80
                        } 
                        size={50}
                        style={{ color: '#39FF14' }}
                      />
                      <span style={{ fontSize: '12px', color: '#a0a0ab', fontWeight: 500 }}>Compatibility Score</span>
                    </div>
                  </div>

                  {/* AI Target Job Context */}
                  {favoriteFeedback?.job && (
                    <div style={{
                      marginBottom: '16px',
                      padding: '10px 14px',
                      borderRadius: '8px',
                      backgroundColor: 'rgba(255, 255, 255, 0.03)',
                      borderLeft: '3px solid #FF00FF',
                      fontSize: '13px',
                      color: '#e4e4e7',
                      wordBreak: 'break-word',
                      overflowWrap: 'anywhere'
                    }}>
                      <strong style={{ color: '#FF00FF' }}>Target Job Description:</strong>{' '}
                      {favoriteFeedback.job}
                    </div>
                  )}

                  {/* Formatted Response Body */}
                  <div style={{
                    flex: 1,
                    overflowY: 'auto',
                    maxHeight: '620px',
                    paddingRight: '8px',
                    fontSize: '14px',
                    color: '#e4e4e7',
                    lineHeight: '1.6',
                    wordBreak: 'break-word',
                    overflowWrap: 'anywhere'
                  }} className="custom-scrollbar">
                    {favoriteFeedback?.response ? (
                      <div dangerouslySetInnerHTML={{ __html: makeFinalResult(favoriteFeedback.response) }} />
                    ) : (
                      <div style={{ color: '#a0a0ab', textAlign: 'center', padding: '40px 0' }}>
                        No starred AI Resume Feedback available for this profile.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>


      <Modal className={'modalContent'} open={openPdf} onClose={() => setOpenPdf(false)}   >
        <div style={{ margin: 0, backgroundColor: 'white', width: screenWidth }} className={'modalContent'}>

          <Button className='backbutton' onClick={() => setOpenPdf(false)}>Close</Button>




          <Worker workerUrl={workerUrl}>
            <Viewer
              fileUrl={serverConfig.dev.url + 'images/pdf/' + (defaultPdf || editUsuarioData.pdf)}
              plugins={[
                // Register plugins
                defaultLayoutPluginInstance,
              ]}

            />
          </Worker>


        </div>
      </Modal>
      <Modal open={scoutInfo} onClose={() => handlerCloseModal()} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
        <div style={{
          backgroundColor: '#0a0a0a',
          color: '#ffffff',
          width: isMobile ? '95%' : '90%',
          maxWidth: '1350px',
          maxHeight: '90vh',
          borderRadius: '16px',
          border: '1px solid rgba(138, 46, 226, 0.3)',
          boxShadow: '0 8px 32px 0 rgba(0, 255, 255, 0.15)',
          display: 'flex',
          flexDirection: 'column',
          outline: 'none',
          fontFamily: '"Outfit", "Inter", sans-serif',
          overflow: 'hidden'
        }}>
          {/* Modal Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            backgroundColor: '#111115'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <Avatar 
                src={selectedScout?.image ? serverConfig.dev.url + 'images/' + selectedScout.image : "https://robohash.org/" + (selectedScout?.name || "avatar")}
                style={{ width: '48px', height: '48px', border: '2px solid #00FFFF', boxShadow: '0 0 10px rgba(0, 255, 255, 0.3)' }}
              />
              <div style={{ textAlign: 'left' }}>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#ffffff' }}>
                  {selectedScout?.name || "Unknown Scout"}
                </h2>
                <span style={{ fontSize: '14px', color: '#00FFFF', fontWeight: 500 }}>
                  {editUsuarioData.professionalTitle || 'No Title'}
                </span>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {selectedRecommendation?._id && selectedRecommendation?.status === 'Under Review' && (
                <>
                  <Button 
                    onClick={() => {
                      handlerCloseModal();
                      acceptRequest(selectedRecommendation);
                    }}
                    variant="contained"
                    style={{
                      background: 'linear-gradient(45deg, #8A2BE2, #00FFFF)',
                      color: '#ffffff',
                      padding: '6px 16px',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '13px',
                      borderRadius: '6px'
                    }}
                  >
                    Accept Request
                  </Button>
                  <Button 
                    onClick={() => {
                      handleOpenRejectModal(selectedRecommendation);
                    }}
                    variant="outlined"
                    style={{
                      color: '#FF3366',
                      borderColor: 'rgba(255, 51, 102, 0.4)',
                      backgroundColor: 'rgba(255, 51, 102, 0.05)',
                      padding: '6px 16px',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '13px',
                      borderRadius: '6px'
                    }}
                    sx={{
                      '&:hover': {
                        borderColor: '#FF3366',
                        backgroundColor: 'rgba(255, 51, 102, 0.15)',
                      }
                    }}
                  >
                    Decline
                  </Button>
                </>
              )}
              <Button 
                onClick={() => handlerCloseModal()} 
                style={{ 
                  color: '#ffffff', 
                  borderColor: 'rgba(255,255,255,0.3)',
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  padding: '6px 16px',
                  textTransform: 'uppercase',
                  fontWeight: 600,
                  fontSize: '12px',
                  borderRadius: '6px'
                }}
                variant="outlined"
              >
                Close
              </Button>
            </div>
          </div>

          {/* Modal Content - Scrollable */}
          <div style={{
            padding: '24px',
            overflowY: 'auto',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            backgroundColor: '#0a0a0a'
          }}>
            {/* Dynamic Two-Column Layout */}
            <div style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: '24px',
              width: '100%',
              alignItems: 'stretch'
            }}>
              {/* Left Column: Personal and Professional Info */}
              <div style={{
                flex: isMobile ? '1 1 100%' : '0 0 38%',
                maxWidth: isMobile ? '100%' : '38%',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
              }}>
                {/* Professional Details Section */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 16px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Candidate Details
                  </h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Location</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData.location || 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Years of Experience</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData.yearsOfExperience ? `${editUsuarioData.yearsOfExperience} years` : 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Status</span>
                      <span>
                        {editUsuarioData.employed ? (
                          <span style={{ color: '#FF00FF', backgroundColor: 'rgba(255, 0, 255, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #FF00FF', fontSize: '12px', fontWeight: 600 }}>Employed</span>
                        ) : (
                          <span style={{ color: '#39FF14', backgroundColor: 'rgba(57, 255, 20, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #39FF14', fontSize: '12px', fontWeight: 600 }}>Open to Hire</span>
                        )}
                      </span>
                    </div>
                    {editUsuarioData.englishLevel && (
                      <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                        <span style={{ color: '#a0a0ab', fontSize: '14px' }}>English Level</span>
                        <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData.englishLevel}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Bio Summary Section */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 12px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Bio / Professional Summary
                  </h3>
                  <p style={{
                    margin: 0,
                    color: '#e4e4e7',
                    fontSize: '14px',
                    lineHeight: '1.6',
                    whiteSpace: 'pre-wrap'
                  }}>
                    {editUsuarioData.bio || 'No bio summary provided by the candidate.'}
                  </p>
                </div>

                {/* Curriculum and Links */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px'
                }}>
                  <h3 style={{ margin: 0, color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Documents & Links
                  </h3>
                  
                  {/* CV PDF Button */}
                  {(defaultPdf || editUsuarioData.pdf) ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <span style={{ fontSize: '13px', color: '#a0a0ab' }}>Uploaded CV: {defaultPdf || editUsuarioData.pdf}</span>
                      <Button 
                        variant='contained' 
                        onClick={() => setOpenPdf(true)}
                        style={{
                          background: 'linear-gradient(45deg, #8A2BE2, #00FFFF)',
                          color: '#ffffff',
                          fontWeight: 600,
                          textTransform: 'none'
                        }}
                      >
                        Open Curriculum Viewer
                      </Button>
                    </div>
                  ) : (
                    <span style={{ fontSize: '14px', color: '#a0a0ab' }}>No resume PDF uploaded.</span>
                  )}

                  {/* Target Job Link */}
                  {selectedRecommendation.link && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '12px' }}>
                      <span style={{ fontSize: '13px', color: '#a0a0ab' }}>Target Job URL</span>
                      <Button
                        href={`${selectedRecommendation.link}`}
                        target="_blank"
                        variant="outlined"
                        style={{
                          color: '#39FF14',
                          borderColor: 'rgba(57, 255, 20, 0.4)',
                          backgroundColor: 'rgba(57, 255, 20, 0.05)',
                          fontWeight: 600,
                          textTransform: 'none'
                        }}
                      >
                        View Job Link
                      </Button>
                    </div>
                  )}
                </div>
              </div>

              {/* Right Column: AI Resume Feedback Analysis (Favorite) */}
              <div style={{
                flex: isMobile ? '1 1 100%' : '1 1 62%',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
              }}>
                {/* Favorite AI Feedback Card */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '24px',
                  border: '1px solid rgba(0, 255, 255, 0.3)',
                  boxShadow: '0 0 15px rgba(0, 255, 255, 0.05)',
                  textAlign: 'left',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  minWidth: 0
                }}>
                  {/* Header: AI Matching Feedback */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(0, 255, 255, 0.2)', paddingBottom: '12px', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
                    <div>
                      <h3 style={{ margin: 0, color: '#00FFFF', fontSize: '18px', fontWeight: 600 }}>
                        AI Match Analysis
                      </h3>
                      <span style={{ fontSize: '12px', color: '#39FF14', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginTop: '2px' }}>
                        ★ Starred Feedback
                      </span>
                    </div>
                    
                    {/* Animated/Glowing Matching Circular Score */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <CircularProgressWithLabel 
                        value={
                          favoriteFeedback?.response ? (
                            (() => {
                              try {
                                const parsed = JSON.parse(favoriteFeedback.response);
                                if (parsed.grade !== undefined) {
                                  let num = parseFloat(String(parsed.grade));
                                  if (!isNaN(num)) {
                                    if (num <= 1) num = num * 100;
                                    else if (num <= 10) num = num * 10;
                                    return Math.round(num);
                                  }
                                }
                              } catch(e) {}
                              return 80;
                            })()
                          ) : 80
                        } 
                        size={50}
                        style={{ color: '#39FF14' }}
                      />
                      <span style={{ fontSize: '12px', color: '#a0a0ab', fontWeight: 500 }}>Compatibility Score</span>
                    </div>
                  </div>

                  {/* AI Target Job Context */}
                  {favoriteFeedback?.job && (
                    <div style={{
                      marginBottom: '16px',
                      padding: '10px 14px',
                      borderRadius: '8px',
                      backgroundColor: 'rgba(255, 255, 255, 0.03)',
                      borderLeft: '3px solid #FF00FF',
                      fontSize: '13px',
                      color: '#e4e4e7',
                      wordBreak: 'break-word',
                      overflowWrap: 'anywhere'
                    }}>
                      <strong style={{ color: '#FF00FF' }}>Target Job Description:</strong>{' '}
                      {favoriteFeedback.job}
                    </div>
                  )}

                  {/* Formatted Response Body */}
                  <div style={{
                    flex: 1,
                    overflowY: 'auto',
                    maxHeight: '620px',
                    paddingRight: '8px',
                    fontSize: '14px',
                    color: '#e4e4e7',
                    lineHeight: '1.6',
                    wordBreak: 'break-word',
                    overflowWrap: 'anywhere'
                  }} className="custom-scrollbar">
                    {favoriteFeedback?.response ? (
                      <div dangerouslySetInnerHTML={{ __html: makeFinalResult(favoriteFeedback.response) }} />
                    ) : (
                      <div style={{ color: '#a0a0ab', textAlign: 'center', padding: '40px 0' }}>
                        No starred AI Resume Feedback available for this profile.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* Reject Confirmation Dialog */}
      <Dialog
        open={openRejectModal}
        onClose={handleCloseRejectModal}
        PaperProps={{
          style: {
            backgroundColor: '#111115',
            color: '#ffffff',
            borderRadius: '16px',
            border: '1px solid rgba(255, 51, 102, 0.4)',
            boxShadow: '0 8px 32px rgba(255, 51, 102, 0.2)',
            maxWidth: '500px',
            padding: '12px',
            fontFamily: '"Outfit", "Inter", sans-serif'
          }
        }}
      >
        <DialogTitle style={{ color: '#FF3366', fontWeight: 700, fontSize: '20px', paddingBottom: '8px' }}>
          Decline Nomination Request
        </DialogTitle>
        <DialogContent style={{ color: '#d1d1d6', fontSize: '14px', lineHeight: '1.6' }}>
          Are you sure you want to decline the nomination request from{' '}
          <strong style={{ color: '#ffffff' }}>
            {recommendationToReject?.scout?.name || 'this candidate'}
          </strong>?
          <div style={{ marginTop: '14px', padding: '12px', backgroundColor: 'rgba(255, 51, 102, 0.07)', borderRadius: '8px', borderLeft: '3px solid #FF3366', fontSize: '13px', color: '#e4e4e7' }}>
            This request will no longer appear in your queue. Other scouters at{' '}
            <strong style={{ color: '#00FFFF' }}>{user?.company?.name || 'your company'}</strong>{' '}
            will still be able to review, accept, or decline it.
          </div>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', gap: '12px' }}>
          <Button
            onClick={handleCloseRejectModal}
            disabled={rejectLoading}
            variant="outlined"
            style={{
              color: '#ffffff',
              borderColor: 'rgba(255, 255, 255, 0.25)',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '8px',
              padding: '6px 18px'
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmReject}
            disabled={rejectLoading}
            variant="contained"
            style={{
              background: 'linear-gradient(45deg, #FF3366, #E0115F)',
              color: '#ffffff',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '8px',
              padding: '6px 20px',
              boxShadow: '0 0 12px rgba(255, 51, 102, 0.35)'
            }}
          >
            {rejectLoading ? <CircularProgress size={20} style={{ color: '#ffffff' }} /> : 'Decline Request'}
          </Button>
        </DialogActions>
      </Dialog>




    </Container>
  );
};

const mapStateToProps = (state: any) => ({
  usuarios: state.usuarios.usuarios,
  user: state.user.user,
  isLoadingInventory: state.produtos.isLoadingInventory,

  consultedProduts: state.produtos.consultedProduts,
  produtos: state.produtos.produtos,
  inventories: state.produtos.inventories,
  imagesByReferencia: state.referencias.imagesByReferencia,
  isLoadingCreateUsuario: state.usuarios.isLoadingCreateUsuario,
  empresas: state.empresas.empresas
});

const mapDispatchToProps = {
  fetchEmpresas,
  getCategorias,
  getUsuarios,
  deleteUsuario,
  createUsuario,
  updateUsuario,
  getAllInventoryStart,
  getInventoriesByCategory,
  getInventoriesByFilter,
  consultProductStart,
  getImagesByReferencia,

};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ScoutersPage);
